module.exports = __webpack_public_path__ + "static/img/4.0fc8e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6/4.png
// module id = KKJQ
// module chunks = 1